export const workExperience = [
  {
    id: "1",
    position: "Full Stack Developer",
    organization: "ansrsource",
    duration: "Oct 2022 - June 2025",
    type: "Full Time",
    technologies: [
      "Next.js",
      "React.js",
      "React Native",
      "Material UI",
      "WordPress",
      "Node.js",
      "Express",
      "HTML5/CSS3",
    ],
    description: [
      "Developed a scalable, responsive Learning Management System (LMS) using Next.js and the React Context API for efficient state management, implementing dynamic page routing, JWT-based authentication, and infinite scrolling to support 250+ active users across 200+ courses.",
      "Built a modular accessibility platform with Next.js, featuring role-based access control and OAuth 2.0 authentication, streamlining onboarding and integration of three distinct LMS platforms through unified API endpoints. ",
      "Led the modernization of an LMS mobile app by upgrading Expo (v47 → v50) and React Native (v0.70 → v0.73.6), cutting app crash rates by 15% and improving overall app performance by 25%, with successful Play Store and App Store deployments reaching 500+ downloads.",
      "Engineered a dynamic course authoring interface in Next.js with real-time preview capabilities and customizable theme switching, enabling instructors to design and publish learning content more efficiently.",
    ],
    linkedIn: "https://www.linkedin.com/company/ansrsource/",
  },
  {
    id: "2",
    position: "Technical Writer",
    organization: "GeeksforGeeks",
    duration: "Nov 2023 - Oct 2024",
    type: "Freelance",
    description: [
      "Authored technical articles on React.js, Node.js, full-stack web development, databases, and ChatGPT, amassing 1,00,000+ reads across platforms and establishing expertise in high-demand topics",
      "Crafted in-depth content (1,500+ words per article) optimized with on-page SEO best practices and editorial guidelines.",
    ],
    linkedIn: "https://www.linkedin.com/company/geeksforgeeks/",
  },
];
